<div
  class="flex items-center justify-between border-b border-slate-200 px-6 py-4"
>
  <div>
    <h2
      id="modal-editar-telefono-title"
      class="text-lg font-semibold text-slate-900"
    >
      Editar teléfono
    </h2>
    <p class="text-sm text-slate-500">Actualiza la configuración del número.</p>
  </div>

  <button
    type="button"
    class="rounded-lg p-2 text-slate-500 transition hover:bg-slate-100 hover:text-slate-700"
    (click)="cerrarModal()"
    aria-label="Cerrar modal"
  >
    <i class="bi bi-x-lg text-lg"></i>
  </button>
</div>

<form
  class="space-y-5 px-6 py-5"
  [formGroup]="formTelefono"
  (submit)="$event.preventDefault(); guardarTelefono()"
>
  <div>
    <label for="telefono" class="mb-1 block text-sm font-medium text-slate-700">
      Número de teléfono
    </label>
    <input
      id="telefono"
      type="tel"
      inputmode="tel"
      maxlength="20"
      class="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
      placeholder="Ej: 987654321"
      formControlName="numero"
    />
  </div>

  <div>
    <label
      for="tipoTelefono"
      class="mb-1 block text-sm font-medium text-slate-700"
    >
      Titulo
    </label>
    <input
      id="tipoTelefono"
      type="text"
      maxlength="50"
      class="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
      placeholder="Ej: Teléfono principal, WhatsApp, etc."
      formControlName="titulo"
    />
  </div>

  <div>
    <label
      for="metaPhoneNumberId"
      class="mb-1 block text-sm font-medium text-slate-700"
    >
      ID de número en Meta (phone_number_id)
    </label>
    <input
      id="metaPhoneNumberId"
      type="text"
      maxlength="40"
      class="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
      placeholder="Ej: 112233445566778"
      formControlName="meta_phone_number_id"
    />
  </div>

  <div>
    <label
      for="descripcion"
      class="mb-1 block text-sm font-medium text-slate-700"
    >
      Descripción u observación
    </label>
    <textarea
      id="descripcion"
      rows="3"
      class="w-full resize-none rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
      placeholder="Opcional"
      formControlName="descripcion"
    ></textarea>
  </div>

  <div
    class="flex items-center gap-2 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3"
  >
    <input
      id="activo_telefono"
      type="checkbox"
      class="h-4 w-4 rounded border-slate-300"
      formControlName="activo"
    />
    <label for="activo_telefono" class="text-sm font-medium text-slate-700">
      Teléfono activo
    </label>
  </div>

  <div>
    <label
      for="proveedorTelefono"
      class="mb-1 block text-sm font-medium text-slate-700"
    >
      Proveedor de API
    </label>
    <select
      id="proveedorTelefono"
      class="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-200 bg-white"
      formControlName="proveedor"
    >
      <option value="OFICIAL">Oficial (Meta / WhatsApp Business)</option>
      <option value="NO_OFICIAL">No oficial (Evolution API)</option>
    </select>
    <p class="mt-1 text-xs text-slate-500">
      Define qué API se usará para enviar y recibir mensajes.
    </p>
  </div>

  <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
    <button
      type="button"
      class="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm font-medium text-slate-700 transition hover:bg-slate-50 sm:w-auto"
      (click)="cerrarModal()"
    >
      Cancelar
    </button>

    <button
      type="submit"
      class="w-full rounded-xl bg-blue-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-blue-700 sm:w-auto"
    >
      Guardar cambios
    </button>
  </div>
</form>

<app-toast aria-live="polite" aria-atomic="true"></app-toast>
